//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TelephoneInformationDisplayItem } from './TelephoneInformationDisplayItem';
import { EmailInformationDisplayItem } from './EmailInformationDisplayItem';
import { FamilyDisplayItem } from './FamilyDisplayItem';
import { CardOnFileType, LoginAccessStatus } from './Enums';

export class ParentDisplayItem extends ItemBase {
    ID: string | null = null;
    FirstName: string | null = null;
    LastName: string | null = null;
    FullName: string | null = null;
    Title: string | null = null;
    FormalName: string | null = null;
    HomeTelephone: TelephoneInformationDisplayItem | null = null;
    MobileTelephone: TelephoneInformationDisplayItem | null = null;
    WorkTelephone: TelephoneInformationDisplayItem | null = null;
    Address: string | null = null;
    Email: EmailInformationDisplayItem | null = null;
    HasEmailAddress: boolean = false;
    HasSMSNumber: boolean = false;
    Note: string | null = null;
    IsActive: boolean = false;
    IsPreferredInvoiceRecipient: boolean = false;
    SendEmailReminders: boolean = false;
    SendSMSReminders: boolean = false;
    IncludeInContactList: boolean = false;
    LastLogin: string | null = null;
    CardOnFileType: CardOnFileType = CardOnFileType.No;
    AdultStudentID: string | null = null;
    FamilyID: string | null = null;
    Family: FamilyDisplayItem | null = null;
    HasMfa: boolean = false;
    AccessStatus: LoginAccessStatus = LoginAccessStatus.NoAccess;

    constructor(initializer?: Partial<ParentDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ParentDisplayItem";
}
